import $ from 'jquery';
import './style.scss';

const loopThroughRange = (endOfRange = 1, callback) =>
  Array.from(Array(endOfRange + 1), callback);

function loadMore(table) {
  const $table = $(table);
  const $loadMoreBtn = $table.siblings('.js-comparison-table__loadMore');
  const numberOfRows = Number(table[0].dataset.loadMoreRows) - 1;

  const showRows = ($elements) => {
    $elements
      .removeClass('is-hidden')
      .attr('aria-hidden', false)
      // Removes display:table-row style being automatically added when rows are hidden
      .css('display', '');
  };

  const hideLoadMore = () => {
    const allRowsShown = !$table.find('.js-comparison-table__row.is-hidden:not(.is-filtered)').length;
    if (allRowsShown) {
      $loadMoreBtn.hide();
    } else {
      $loadMoreBtn.show();
    }
  };

  const displayAllRows = (event) => {
    event.preventDefault();
    showRows($table.find('.js-comparison-table__row.is-hidden:not(.is-filtered)'));

    hideLoadMore();

    $.trackEvent('Pagination', 'Click load more');
    $table.trigger('update');
  };

  const resetShownRows = () => {
    const $allRows = $table.find('.js-comparison-table__row:not(.is-filtered)');
    $table.find('.js-comparison-table__row').addClass('is-hidden');

    loopThroughRange(numberOfRows, (i, index) => {
      const currentRow = $allRows[index];
      if ($(currentRow).length) {
        showRows($(currentRow));
      }
      return i;
    });

    hideLoadMore($table, $loadMoreBtn);
  };

  $loadMoreBtn.find('button').on('click', displayAllRows);
  $table.on('reset-shown-rows', resetShownRows);
}

export default loadMore;
